export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://backend.ps.al"
export const WS_URL = process.env.REACT_APP_WS_URL || "ws://192.168.1.230:8088/ws/notification/"
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || "https://sistemi.ps.al"
export const TIMEOUT = parseInt(process.env.REACT_APP_TIMEOUT || "20000", 10)